import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const SetUpDirectDeposit = gql`
  mutation SetupDirectDeposit($input: SetupDirectDepositInput!) {
    setupDirectDeposit(input: $input) {
      __typename
      ... on SetupDirectDepositSuccess {
        url
        __typename
      }
      ... on SetupDirectDepositError {
        ...error
      }
      ... on Error {
        ...error
      }
    }
  }
  ${error}
`;
export default SetUpDirectDeposit;
